import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import api from "../Utils/api";
import { setApplications } from "../store/reducer/application";
import { logOut, setAuth } from "../store/reducer/auth";
import { setLoading } from "../store/reducer/loading";
import { setMessages } from "../store/reducer/message";
import { setUsers } from "../store/reducer/user";
import Footer from "./Footer";
import Header from "./Header";
import SideBar from "./SideBar";

const Main = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const loadUser = async () => {
      dispatch(setLoading(true));
      try {
        const [
          messageResponse,
          applicationResponse,
          usersResponse,
          authResponse,
        ] = await Promise.all([
          api.get("message"),
          api.get("application"),
          api.get("users"),
          api.get("users/current"),
        ]);
        dispatch(setMessages(messageResponse.data.messages));
        dispatch(setApplications(applicationResponse.data.applications));
        dispatch(setUsers(usersResponse.data.users));
        dispatch(setAuth(authResponse.data));
      } catch (error) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh_token");
          dispatch(logOut());
          navigate("/login");
        }
      } finally {
        dispatch(setLoading(false));
      }
    };
    loadUser();
  }, []);

  document.body.classList.remove("login-page");

  // useEffect(() => {
  //   let isCancelled = false;

  //   const poll = async () => {
  //     if (isCancelled) return;
  //     try {
  //       const [messages, applications, users] = await Promise.all([
  //         api.get("message"),
  //         api.get("application"),
  //         api.get("user"),
  //       ]);
  //       dispatch(setMessages(messages.data.messages));
  //       dispatch(setApplications(applications.data.applications));
  //       dispatch(setUsers(users.data.users));
  //     } catch (error) {
  //       if (error.response?.status === 401) {
  //         localStorage.removeItem("token");
  //         localStorage.removeItem("refresh_token");
  //         dispatch(logOut());
  //         navigate("/login");
  //       }
  //     }
  //     if (!isCancelled) {
  //       setTimeout(poll, 60000);
  //     }
  //   };

  //   poll();

  //   return () => {
  //     isCancelled = true;
  //   };
  // }, []);

  return (
    <>
      <Header />
      <SideBar />
      <div className="content-wrapper">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Main;
